import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import BaseAutocomplete from '../../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { convertToSentenceCase } from '../../../../../../../shared/utils/convert-to-sentence-case/convert-to-sentence-case.util';
import FormControl from '../../../../../../shared/components/ui/FormControl';
import { StatesEnum } from '../../../../../../shared/enums/states.enum';
import { mapStatesEnumToItemLabelModel } from '../../../../../../shared/utils/mapping/mapping.utils';
import { optionEquality } from '../../../../../../shared/utils/option-equality/option-equality.util';
import { ExceptedAppsReleaseFormProps } from '../../../types/excepted-apps-release-form-props.type';

const ReleaseStatusSelect: FunctionComponent<ExceptedAppsReleaseFormProps> = (
  props: PropsWithChildren<ExceptedAppsReleaseFormProps>
) => {
  const { values, setFieldValue, handleBlur } = props;

  const optionsStatus = [
    StatesEnum.PENDING,
    StatesEnum.RELEASED,
    StatesEnum.SAVED,
  ];

  return (
    <FormControl>
      <BaseAutocomplete
        multiple={false}
        disableClearable={false}
        freeSolo={false}
        id="status"
        value={values.status ?? null}
        onChange={(event, value) => setFieldValue('status', value)}
        onBlur={handleBlur}
        options={optionsStatus.map(mapStatesEnumToItemLabelModel)}
        getOptionLabel={option => convertToSentenceCase(option.label)}
        isOptionEqualToValue={optionEquality}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            errors={props.errors}
            id="status"
            label="Status"
            name="status"
            touched={props.touched}
            required
          />
        )}
      />
    </FormControl>
  );
};

export default ReleaseStatusSelect;
